export default function ShareIcon() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M16.96 6.16992C18.96 7.55992 20.34 9.76992 20.62 12.3199"
          className="svg-icon"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.49023 12.3702C3.75023 9.83021 5.11023 7.62021 7.09023 6.22021"
          className="svg-icon"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.19043 20.9399C9.35043 21.5299 10.6704 21.8599 12.0604 21.8599C13.4004 21.8599 14.6604 21.5599 15.7904 21.0099"
          className="svg-icon"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0603 7.70014C13.5956 7.70014 14.8403 6.45549 14.8403 4.92014C14.8403 3.38479 13.5956 2.14014 12.0603 2.14014C10.5249 2.14014 9.28027 3.38479 9.28027 4.92014C9.28027 6.45549 10.5249 7.70014 12.0603 7.70014Z"
          className="svg-icon"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.8298 19.9199C6.36516 19.9199 7.60981 18.6752 7.60981 17.1399C7.60981 15.6045 6.36516 14.3599 4.8298 14.3599C3.29445 14.3599 2.0498 15.6045 2.0498 17.1399C2.0498 18.6752 3.29445 19.9199 4.8298 19.9199Z"
          className="svg-icon"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1696 19.9199C20.705 19.9199 21.9496 18.6752 21.9496 17.1399C21.9496 15.6045 20.705 14.3599 19.1696 14.3599C17.6343 14.3599 16.3896 15.6045 16.3896 17.1399C16.3896 18.6752 17.6343 19.9199 19.1696 19.9199Z"
          className="svg-icon"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
